module.exports = __webpack_public_path__ + "a254c3d6baf8a3d9d981f2d4ab5bca2e.png";